import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  getFirestore,
  collection,
  getDocs,
  getDoc,
  query,
  where,
  limit,
  orderBy
} from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Constants
export const dbCollections = {
  BLOGS: "blogs",
};

export const storageCollections = {
  BLOGS: "blogs",
};

// Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyDJncECP4a2eC4qrTOmhD830CG3IEzO6v8",
  authDomain: "eyecare-website-d64a6.firebaseapp.com",
  projectId: "eyecare-website-d64a6",
  storageBucket: "eyecare-website-d64a6.firebasestorage.app",
  messagingSenderId: "625586864355",
  appId: "1:625586864355:web:112cda2ec19f89e42185d6",
  measurementId: "G-K22HS4YSVP",
};

// Init Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Fetch all blogs
export async function getBlogs() {
  try {
    const blogsQuery = query(
      collection(db, dbCollections.BLOGS),
      orderBy("createdAt", "desc")
    );
    const snapshot = await getDocs(blogsQuery);

    return snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
  } catch (error) {
    console.error("Error fetching blogs:", error);
    throw error;
  }
}

// ✅ Fetch a single blog by condition
export async function getSingleDoc({ collectionName, condition }) {
  try {
    const q = query(collection(db, collectionName), condition, limit(1));
    const snapshot = await getDocs(q);

    if (!snapshot.empty) {
      return {
        id: snapshot.docs[0].id,
        ...snapshot.docs[0].data(),
      };
    }
    return null;
  } catch (error) {
    console.error("Error fetching single document:", error);
    throw error;
  }
}
